import { render, staticRenderFns } from "./PreOrderProduct.vue?vue&type=template&id=bc45c65a&scoped=true&"
import script from "./PreOrderProduct.vue?vue&type=script&lang=js&"
export * from "./PreOrderProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc45c65a",
  null
  
)

export default component.exports